// angular imports
import { Component, Input } from '@angular/core';

// cc-common imports
import { IconConstants } from 'cc-common';

// models imports
import { KeyValueResultDto } from '../../../_models/key-value-result-dto';

@Component({
    selector: 'app-workflow-status-breadcrumb',
    templateUrl: './workflow-status-breadcrumb.component.html',
    styleUrls: ['./workflow-status-breadcrumb.component.scss']
})
export class WorkflowStatusBreadcrumbComponent {
    @Input() breadCrumbs: Array<KeyValueResultDto> = [];

    iconNext = IconConstants.NEXT;
    iconHelp = IconConstants.HELP;
}
